import { TRANSFER_STEPS } from "~/stores/TransferStore"

export default defineNuxtPlugin((nuxtApp) => {
	const transferStore = useTransferStore()
	const { onTransferStep } = storeToRefs(transferStore)

	const claimStore = useClaimStore()
	const { eventSelected, onClaimStep } = storeToRefs(claimStore)
	const credentialStore = useCredentialStore()

	const router = useRouter()

	const selectedEventHasClaimableLodging = () => {
		if (!eventSelected.value || !eventSelected.value.id) {
			return false
		}

		return credentialStore
			.getEventLodgings(eventSelected.value.id)
			.some((cred) => !cred.isLockedByTicketSwap)
	}

	nuxtApp.provide("nav", {
		$goBack: () => {
			router.back()
		},

		$startTransfer: () => {
			transferStore.$reset()
			navigateTo("/transferItems")
		},

		$prevTransferStep: () => {
			if (onTransferStep.value > TRANSFER_STEPS.EVENT) {
				onTransferStep.value = --onTransferStep.value
			} else {
				router.back()
			}
		},

		$nextTransferStep: () => {
			if (onTransferStep.value < TRANSFER_STEPS.CONFIRM) {
				onTransferStep.value = ++onTransferStep.value
			}
		},

		$startClaim: (event = null) => {
			claimStore.$reset()
			if (event) {
				claimStore.setEventSelected(event)
				claimStore.setOnStep(2)
			}
			navigateTo("/claimItems")
		},

		$prevClaimStep: () => {
			if (onClaimStep.value > 1) {
				if (onClaimStep.value === 4 && !selectedEventHasClaimableLodging()) {
					onClaimStep.value = 2
					return
				}

				onClaimStep.value = --onClaimStep.value
			} else {
				router.back()
			}
		},

		$nextClaimStep: () => {
			if (onClaimStep.value === 2 && !selectedEventHasClaimableLodging()) {
				onClaimStep.value = 4
				return
			}

			if (onClaimStep.value < 4) {
				onClaimStep.value = ++onClaimStep.value
			}
		},
	})
})
